'use client';
import { Navbar } from '../../navbar';
import LiveVideoContainer from '../components/LiveVideoContainer';
import SSVNavbar from '../components/SSVNavbar';
import { CMSData } from '../s-2025/type';

interface SSVMettingLiveProps {
  cmsData: CMSData;
  isExternalDomain?: boolean;
}

export const SSVMettingLive: React.FC<SSVMettingLiveProps> = ({
  isExternalDomain = false,
  cmsData,
}) => {
  const mettingMainConfig = cmsData.meetingMainConfig?.[0] || {};
  const { liveSourceUrl } = mettingMainConfig || {};
  return (
    <div className="h-full flex flex-col">
      {/* 导航 */}
      {isExternalDomain ? (
        <SSVNavbar className="flex-shrink-0 mobile:!sticky" />
      ) : (
        <div className="relative flex-shrink-0 mobile:h-24 bg-white mobile:-mt-12">
          <Navbar />
        </div>
      )}
      <LiveVideoContainer src={liveSourceUrl}></LiveVideoContainer>
    </div>
  );
};
